module.exports = __webpack_public_path__ + "p6_img3.jpg?be65f895c55f99289a18f77623215b9e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p6/p6_img3.jpg
// module id = 128
// module chunks = 0